const JOB_ALERT_SOUND_URL = "/sounds/job-alert-loop.mp3";

let jobAlertAudio: HTMLAudioElement | null = null;

export function playJobAlertLoop(): void {
  if (typeof window === "undefined") return;
  stopJobAlertLoop();
  const audio = new Audio(JOB_ALERT_SOUND_URL);
  audio.loop = true;
  jobAlertAudio = audio;
  void audio.play().catch(() => {
    jobAlertAudio = null;
  });
}

export function stopJobAlertLoop(): void {
  if (!jobAlertAudio) return;
  jobAlertAudio.pause();
  jobAlertAudio.currentTime = 0;
  jobAlertAudio = null;
}
